import { render, staticRenderFns } from "./DecisionsView.vue?vue&type=template&id=45172f50&"
import script from "./DecisionsView.vue?vue&type=script&lang=ts&"
export * from "./DecisionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports